export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["معالجة دفع تجريبية."])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["لا تُستخدم معاملات حقيقية أو أموال حقيقية. لعرض الإمكانات فقط."])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zentrolink"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["المستندات القانونية"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["شروط الخدمة"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["سياسة الخصوصية"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Datenschutzerklärung"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["العودة إلى لوحة التحكم"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["هذا المستند غير متاح حاليًا."])}
}